import { LoadingDirectiveModule } from '@shared/loading-directive/loading-directive.module';
import { NgModule } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';

import { FuseSidebarModule, FuseThemeOptionsModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';

import { ContentModule } from '@app/components-fuse/layout/components/content/content.module';
import { FooterModule } from '@app/components-fuse/layout/components/footer/footer.module';
import { NavbarModule } from '@app/components-fuse/layout/components/navbar/navbar.module';
import { QuickPanelModule } from '@app/components-fuse/layout/components/quick-panel/quick-panel.module';
import { ToolbarModule } from '@app/components-fuse/layout/components/toolbar/toolbar.module';

import { HorizontalLayout1Component } from '@app/components-fuse/layout/horizontal/layout-1/layout-1.component';

@NgModule({
    declarations: [
        HorizontalLayout1Component
    ],
    imports     : [
        MatSidenavModule,

        FuseSharedModule,
        FuseSidebarModule,
        FuseThemeOptionsModule,

        ContentModule,
        FooterModule,
        NavbarModule,
        QuickPanelModule,
        ToolbarModule
    ],
    exports     : [
        HorizontalLayout1Component
    ]
})
export class HorizontalLayout1Module
{
}
